import { render, staticRenderFns } from "./SignupTemplate.vue?vue&type=template&id=ff60366c&scoped=true&"
import script from "./SignupTemplate.vue?vue&type=script&lang=js&"
export * from "./SignupTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SignupTemplate.vue?vue&type=style&index=0&id=ff60366c&prod&lang=sass&scoped=true&"
import style1 from "./SignupTemplate.vue?vue&type=style&index=1&id=ff60366c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff60366c",
  null
  
)

export default component.exports